import type { SVGProps } from '@integrations/react'
import { uiSize } from '@utils'

interface Props extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
  /** Rendered width and height in px; `null` leaves sizing to the host's CSS. */
  size?: number | null
}

function MessageIcon({ size = 22, strokeWidth = 2, ...props }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      aria-hidden='true'
      {...props}
    >
      <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
    </svg>
  )
}

export default MessageIcon
